module.exports = __webpack_public_path__ + "static/media/19.e2f6781d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/19.png
// module id = 1301
// module chunks = 0